import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VueBaseTranslationResolve, WINDOW_PROVIDERS } from '@vue/vueframework';
import { RetrieveUsernameComponent } from './retrieve-username/retrieve-username.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AccountRecoveryBundleResolve } from './shared/resolvers/accountrecovery.resolve';
import { AccountServicesBundleResolve } from './shared/resolvers/accountservices.resolve';
import { DisplayUsernameComponent } from './display-username/display-username.component';
import { RetrievePasswordComponent } from './retrieve-password/retrieve-password.component';
import { PasswordResetOptionsComponent } from './password-reset-options/password-reset-options.component';
import { PasswordResetOptionsResolve } from './shared/resolvers/passwordResetOptions.resolve';
import { LocaleResolve } from './shared/resolvers/locale.resolve';
import { PasswordResetUpdateComponent } from './password-reset-update/password-reset-update.component';
import { PasswordResetWindowResolve } from './shared/resolvers/passwordResetWindow.resolve';
import { ClientResolve } from './shared/resolvers/client.resolve';

/* eslint-disable sort-keys */
const routes: Routes = [
  {
    path: '', children: [
      { path: 'username/lookup/:clientCode', component: RetrieveUsernameComponent,
        resolve: { client: ClientResolve },
        data: {
          pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.RetrieveUsername' }
        }
      },
      { path: 'username/display/:clientCode', component: DisplayUsernameComponent, data: {
        pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.RetrieveUsername' }
      }
      },
      { path: 'passwordreset/usernamelookup/:clientCode', component: RetrievePasswordComponent,
        resolve: { client: ClientResolve },
        data: {
          pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.ResetPassword' }
        }
      },
      { path: 'passwordreset/options/:clientCode', component: PasswordResetOptionsComponent,
        resolve: { passwordResetOptions: PasswordResetOptionsResolve }, data: {
          pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.ResetPassword' }
        }
      },
      { path: 'passwordreset/update/:resetWindowId/:resetWindowHash/:clientCode',
        component: PasswordResetUpdateComponent,
        resolve: { passwordWindowResolve: PasswordResetWindowResolve, client: ClientResolve }, data: {
          pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.ResetPassword' }
        }
      },
      { path: 'notfound', component: PageNotFoundComponent, data: {
        pageTitle: { i18nBundle: 'AccountRecovery', key: 'title.PageNotFound' }
      }
      },
      { path: '**', redirectTo: 'notfound' }
    ], resolve: {
      locale: LocaleResolve,
      base: VueBaseTranslationResolve,
      accountRecovery: AccountRecoveryBundleResolve,
      accountServices: AccountServicesBundleResolve
    }
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [ WINDOW_PROVIDERS ]
})
export class AppRoutingModule { }
